module.exports = __webpack_public_path__ + "static/media/nft.da7cb6b9.mp4";